import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FileTextIcon, CheckIcon, ClockIcon, AlertCircleIcon, ShieldIcon, PenToolIcon, EyeIcon, ArrowRightIcon, XIcon, DownloadIcon, InfoIcon, CheckCircleIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
const MSMEApplications = () => {
  const [showSigningModal, setShowSigningModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleSign = () => {
    setShowSigningModal(false);
    setShowConfirmation(true);
  };
  if (showConfirmation) {
    return <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4" data-id="element-2031">
        <div className="w-full max-w-md" data-id="element-2032">
          <Card data-id="element-2033">
            <div className="text-center mb-6" data-id="element-2034">
              <div className="flex justify-center mb-4" data-id="element-2035">
                <div className="w-16 h-16 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-2036">
                  <CheckCircleIcon className="w-8 h-8 text-success" data-id="element-2037" />
                </div>
              </div>
              <h2 className="text-xl font-bold text-success" data-id="element-2038">
                Contract Signed Successfully!
              </h2>
              <p className="text-neutral-500 mt-2" data-id="element-2039">
                Your micro-sukuk contract has been signed and will now proceed
                to marketplace listing.
              </p>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg mb-6" data-id="element-2040">
              <h3 className="font-medium mb-2" data-id="element-2041">Next Steps</h3>
              <ol className="space-y-3 text-sm" data-id="element-2042">
                <li className="flex items-start" data-id="element-2043">
                  <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-2044">
                    <span className="text-white text-xs" data-id="element-2045">1</span>
                  </div>
                  <div data-id="element-2046">
                    <span className="font-medium" data-id="element-2047">Marketplace Listing</span>
                    <p className="text-neutral-500" data-id="element-2048">
                      Your micro-sukuk will be listed on the marketplace within
                      24 hours.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2049">
                  <div className="w-6 h-6 rounded-full bg-neutral-200 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-2050">
                    <span className="text-neutral-600 text-xs" data-id="element-2051">2</span>
                  </div>
                  <div data-id="element-2052">
                    <span className="font-medium" data-id="element-2053">Investor Subscription</span>
                    <p className="text-neutral-500" data-id="element-2054">
                      Investors will be able to subscribe to your micro-sukuk.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-2055">
                  <div className="w-6 h-6 rounded-full bg-neutral-200 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-2056">
                    <span className="text-neutral-600 text-xs" data-id="element-2057">3</span>
                  </div>
                  <div data-id="element-2058">
                    <span className="font-medium" data-id="element-2059">Fund Disbursement</span>
                    <p className="text-neutral-500" data-id="element-2060">
                      Once fully subscribed, funds will be disbursed to the
                      vendor.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
            <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-2061">
              <div className="flex items-center" data-id="element-2062">
                <InfoIcon className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-2063" />
                <p className="text-sm" data-id="element-2064">
                  You'll receive notifications about your listing status and
                  investor subscriptions. The typical funding period is 5-7
                  business days.
                </p>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-2065">
              <Link to="/dashboard/msme" data-id="element-2066">
                <Button variant="primary" data-id="element-2067">Return to Dashboard</Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>;
  }
  return <div className="max-w-4xl mx-auto" data-id="element-2068">
      <div className="mb-6" data-id="element-2069">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-2070">
          My Micro-Sukuk Applications
        </h1>
        <p className="text-neutral-400" data-id="element-2071">
          Track and manage your micro-sukuk applications
        </p>
      </div>
      {/* Active Applications */}
      <section className="mb-8" data-id="element-2072">
        <Card data-id="element-2073">
          <div className="flex items-center mb-6" data-id="element-2074">
            <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-4" data-id="element-2075">
              <FileTextIcon className="w-6 h-6 text-primary" data-id="element-2076" />
            </div>
            <div data-id="element-2077">
              <h3 className="font-bold text-lg" data-id="element-2078">#MS2023-104</h3>
              <div className="flex items-center text-sm text-neutral-400" data-id="element-2079">
                <span data-id="element-2080">Equipment Purchase</span>
                <span className="mx-2" data-id="element-2081">•</span>
                <span data-id="element-2082">RM 25,000</span>
                <span className="mx-2" data-id="element-2083">•</span>
                <span data-id="element-2084">Submitted 2 days ago</span>
              </div>
            </div>
            <div className="ml-auto bg-warning bg-opacity-10 text-warning px-3 py-1 rounded-full text-sm font-medium" data-id="element-2085">
              Action Required
            </div>
          </div>
          {/* Application Progress */}
          <div className="relative mb-8" data-id="element-2086">
            <div className="absolute top-4 left-0 right-0 h-1 bg-neutral-200" data-id="element-2087">
              <div className="bg-primary h-1" style={{
              width: '60%'
            }} data-id="element-2088"></div>
            </div>
            <div className="flex justify-between relative" data-id="element-2089">
              <div className="flex flex-col items-center w-1/6" data-id="element-2090">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2091">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2092" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2093">
                  Application Submitted
                </div>
                <div className="text-xs text-success text-center" data-id="element-2094">
                  Completed
                </div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2095">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2096">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2097" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2098">
                  Digital Advisor
                </div>
                <div className="text-xs text-success text-center" data-id="element-2099">Approved</div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2100">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2101">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2102" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2103">
                  Rating Agency
                </div>
                <div className="text-xs text-success text-center" data-id="element-2104">Low Risk</div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2105">
                <div className="w-8 h-8 rounded-full bg-warning flex items-center justify-center z-10 mb-2" data-id="element-2106">
                  <AlertCircleIcon className="w-4 h-4 text-white" data-id="element-2107" />
                </div>
                <div className="text-xs font-medium text-center text-warning" data-id="element-2108">
                  Shariah Review
                </div>
                <div className="text-xs text-warning text-center" data-id="element-2109">
                  Action Required
                </div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2110">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-2111">
                  <span className="text-neutral-400 text-sm" data-id="element-2112">5</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2113">
                  Contract Signing
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-2114">
                  Pending
                </div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2115">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-2116">
                  <span className="text-neutral-400 text-sm" data-id="element-2117">6</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2118">
                  Marketplace
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-2119">
                  Pending
                </div>
              </div>
            </div>
          </div>
          {/* Action Required Section */}
          <div className="bg-warning bg-opacity-5 border border-warning border-opacity-20 rounded-lg p-4 mb-6" data-id="element-2120">
            <div className="flex items-center mb-2" data-id="element-2121">
              <AlertCircleIcon className="w-5 h-5 text-warning mr-2" data-id="element-2122" />
              <h4 className="font-medium text-warning" data-id="element-2123">Action Required</h4>
            </div>
            <p className="text-sm text-neutral-500 mb-4" data-id="element-2124">
              The Shariah advisor has requested additional information about
              equipment maintenance responsibilities during the lease period.
              Please provide the requested details to proceed with the review.
            </p>
            <div className="space-y-3" data-id="element-2125">
              <div className="flex items-center text-sm" data-id="element-2126">
                <CheckIcon className="w-4 h-4 text-success mr-2" data-id="element-2127" />
                <span data-id="element-2128">Clarify who will be responsible for major repairs</span>
              </div>
              <div className="flex items-center text-sm" data-id="element-2129">
                <CheckIcon className="w-4 h-4 text-success mr-2" data-id="element-2130" />
                <span data-id="element-2131">Specify routine maintenance schedule</span>
              </div>
              <div className="flex items-center text-sm" data-id="element-2132">
                <CheckIcon className="w-4 h-4 text-success mr-2" data-id="element-2133" />
                <span data-id="element-2134">Confirm equipment insurance arrangements</span>
              </div>
            </div>
            <Button variant="warning" size="sm" className="mt-4" data-id="element-2135">
              Provide Information
            </Button>
          </div>
          {/* Application Details */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2136">
            <div data-id="element-2137">
              <h4 className="font-medium mb-3" data-id="element-2138">Application Overview</h4>
              <div className="space-y-3" data-id="element-2139">
                <div className="flex justify-between" data-id="element-2140">
                  <span className="text-sm text-neutral-400" data-id="element-2141">Purpose</span>
                  <span className="text-sm font-medium" data-id="element-2142">
                    Equipment Purchase
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-2143">
                  <span className="text-sm text-neutral-400" data-id="element-2144">Amount</span>
                  <span className="text-sm font-medium" data-id="element-2145">RM 25,000</span>
                </div>
                <div className="flex justify-between" data-id="element-2146">
                  <span className="text-sm text-neutral-400" data-id="element-2147">Duration</span>
                  <span className="text-sm font-medium" data-id="element-2148">6 months</span>
                </div>
                <div className="flex justify-between" data-id="element-2149">
                  <span className="text-sm text-neutral-400" data-id="element-2150">Profit Rate</span>
                  <span className="text-sm font-medium" data-id="element-2151">18% p.a.</span>
                </div>
                <div className="flex justify-between" data-id="element-2152">
                  <span className="text-sm text-neutral-400" data-id="element-2153">
                    Monthly Payment
                  </span>
                  <span className="text-sm font-medium" data-id="element-2154">RM 4,271</span>
                </div>
              </div>
            </div>
            <div data-id="element-2155">
              <h4 className="font-medium mb-3" data-id="element-2156">Review Status</h4>
              <div className="space-y-3" data-id="element-2157">
                <div className="flex items-center justify-between" data-id="element-2158">
                  <div className="flex items-center" data-id="element-2159">
                    <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-2160" />
                    <span className="text-sm" data-id="element-2161">Digital Advisor Review</span>
                  </div>
                  <span className="text-sm text-success" data-id="element-2162">Approved</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2163">
                  <div className="flex items-center" data-id="element-2164">
                    <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-2165" />
                    <span className="text-sm" data-id="element-2166">Rating Assessment</span>
                  </div>
                  <span className="text-sm text-success" data-id="element-2167">Low Risk (A)</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2168">
                  <div className="flex items-center" data-id="element-2169">
                    <AlertCircleIcon className="w-5 h-5 text-warning mr-2" data-id="element-2170" />
                    <span className="text-sm" data-id="element-2171">Shariah Review</span>
                  </div>
                  <span className="text-sm text-warning" data-id="element-2172">In Progress</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2173">
                  <div className="flex items-center" data-id="element-2174">
                    <ClockIcon className="w-5 h-5 text-neutral-300 mr-2" data-id="element-2175" />
                    <span className="text-sm" data-id="element-2176">Contract Signing</span>
                  </div>
                  <span className="text-sm text-neutral-400" data-id="element-2177">Pending</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2178">
                  <div className="flex items-center" data-id="element-2179">
                    <ClockIcon className="w-5 h-5 text-neutral-300 mr-2" data-id="element-2180" />
                    <span className="text-sm" data-id="element-2181">Marketplace Listing</span>
                  </div>
                  <span className="text-sm text-neutral-400" data-id="element-2182">Pending</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Previous Application */}
      <section className="mb-8" data-id="element-2183">
        <Card data-id="element-2184">
          <div className="flex items-center mb-6" data-id="element-2185">
            <div className="w-12 h-12 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-4" data-id="element-2186">
              <FileTextIcon className="w-6 h-6 text-success" data-id="element-2187" />
            </div>
            <div data-id="element-2188">
              <h3 className="font-bold text-lg" data-id="element-2189">#MS2023-098</h3>
              <div className="flex items-center text-sm text-neutral-400" data-id="element-2190">
                <span data-id="element-2191">Working Capital</span>
                <span className="mx-2" data-id="element-2192">•</span>
                <span data-id="element-2193">RM 15,000</span>
                <span className="mx-2" data-id="element-2194">•</span>
                <span data-id="element-2195">Ready for Signing</span>
              </div>
            </div>
            <div className="ml-auto bg-success bg-opacity-10 text-success px-3 py-1 rounded-full text-sm font-medium" data-id="element-2196">
              Ready to Sign
            </div>
          </div>
          {/* Progress Steps - Moved outside the success box */}
          <div className="relative mb-8" data-id="element-2197">
            {/* Pipeline Progress Bar */}
            <div className="absolute top-4 left-0 right-0 h-1 bg-neutral-200" data-id="element-2198">
              <div className="bg-success h-1" style={{
              width: '80%'
            }} data-id="element-2199"></div>
            </div>
            {/* Pipeline Stages */}
            <div className="flex justify-between relative" data-id="element-2200">
              <div className="flex flex-col items-center w-1/6" data-id="element-2201">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2202">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2203" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2204">
                  Application
                </div>
                <div className="text-xs text-success text-center" data-id="element-2205">
                  Completed
                </div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2206">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2207">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2208" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2209">
                  Digital Advisor
                </div>
                <div className="text-xs text-success text-center" data-id="element-2210">Approved</div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2211">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2212">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2213" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2214">Rating</div>
                <div className="text-xs text-success text-center" data-id="element-2215">Low Risk</div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2216">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-2217">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-2218" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2219">Shariah</div>
                <div className="text-xs text-success text-center" data-id="element-2220">Approved</div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2221">
                <div className="w-8 h-8 rounded-full bg-warning flex items-center justify-center z-10 mb-2" data-id="element-2222">
                  <AlertCircleIcon className="w-4 h-4 text-white" data-id="element-2223" />
                </div>
                <div className="text-xs font-medium text-center text-warning" data-id="element-2224">
                  Contract
                </div>
                <div className="text-xs text-warning text-center" data-id="element-2225">
                  Action Required
                </div>
              </div>
              <div className="flex flex-col items-center w-1/6" data-id="element-2226">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-2227">
                  <span className="text-neutral-400 text-sm" data-id="element-2228">6</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-2229">
                  Marketplace
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-2230">
                  Pending
                </div>
              </div>
            </div>
          </div>
          {/* Contract Documents */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-2231">
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-2232">
              <div className="flex items-center mb-3" data-id="element-2233">
                <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-2234">
                  <FileTextIcon className="w-4 h-4 text-secondary" data-id="element-2235" />
                </div>
                <h4 className="font-medium" data-id="element-2236">Murabahah Agreement</h4>
              </div>
              <p className="text-xs text-neutral-400 mb-4" data-id="element-2237">
                Main financing agreement
              </p>
              <div className="flex justify-between" data-id="element-2238">
                <Button variant="ghost" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-2240" />} iconPosition="left" data-id="element-2239">
                  Preview
                </Button>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-2242" />} iconPosition="left" data-id="element-2241">
                  Download
                </Button>
              </div>
            </div>
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-2243">
              <div className="flex items-center mb-3" data-id="element-2244">
                <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-2245">
                  <ShieldIcon className="w-4 h-4 text-secondary" data-id="element-2246" />
                </div>
                <h4 className="font-medium" data-id="element-2247">Shariah Certificate</h4>
              </div>
              <p className="text-xs text-neutral-400 mb-4" data-id="element-2248">
                Compliance certification
              </p>
              <div className="flex justify-between" data-id="element-2249">
                <Button variant="ghost" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-2251" />} iconPosition="left" data-id="element-2250">
                  Preview
                </Button>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-2253" />} iconPosition="left" data-id="element-2252">
                  Download
                </Button>
              </div>
            </div>
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-2254">
              <div className="flex items-center mb-3" data-id="element-2255">
                <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-2256">
                  <PenToolIcon className="w-4 h-4 text-secondary" data-id="element-2257" />
                </div>
                <h4 className="font-medium" data-id="element-2258">Payment Schedule</h4>
              </div>
              <p className="text-xs text-neutral-400 mb-4" data-id="element-2259">
                Repayment breakdown
              </p>
              <div className="flex justify-between" data-id="element-2260">
                <Button variant="ghost" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-2262" />} iconPosition="left" data-id="element-2261">
                  Preview
                </Button>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-2264" />} iconPosition="left" data-id="element-2263">
                  Download
                </Button>
              </div>
            </div>
          </div>
          <div className="bg-success bg-opacity-5 border border-success border-opacity-20 rounded-lg p-4 mb-6" data-id="element-2265">
            <div className="flex items-center mb-2" data-id="element-2266">
              <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-2267" />
              <h4 className="font-medium text-success" data-id="element-2268">Ready for Signing</h4>
            </div>
            <p className="text-sm text-neutral-500 mb-4" data-id="element-2269">
              All reviews have been completed and your micro-sukuk has been
              approved. Please review the contract documents and sign them to
              proceed with the marketplace listing.
            </p>
            <Button variant="outline" icon={<PenToolIcon className="w-4 h-4" data-id="element-2271" />} iconPosition="left" onClick={() => setShowSigningModal(true)} data-id="element-2270">
              Sign Documents
            </Button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2272">
            <div data-id="element-2273">
              <h4 className="font-medium mb-3" data-id="element-2274">Application Overview</h4>
              <div className="space-y-3" data-id="element-2275">
                <div className="flex justify-between" data-id="element-2276">
                  <span className="text-sm text-neutral-400" data-id="element-2277">Purpose</span>
                  <span className="text-sm font-medium" data-id="element-2278">Working Capital</span>
                </div>
                <div className="flex justify-between" data-id="element-2279">
                  <span className="text-sm text-neutral-400" data-id="element-2280">Amount</span>
                  <span className="text-sm font-medium" data-id="element-2281">RM 15,000</span>
                </div>
                <div className="flex justify-between" data-id="element-2282">
                  <span className="text-sm text-neutral-400" data-id="element-2283">Duration</span>
                  <span className="text-sm font-medium" data-id="element-2284">3 months</span>
                </div>
                <div className="flex justify-between" data-id="element-2285">
                  <span className="text-sm text-neutral-400" data-id="element-2286">Profit Rate</span>
                  <span className="text-sm font-medium" data-id="element-2287">16% p.a.</span>
                </div>
                <div className="flex justify-between" data-id="element-2288">
                  <span className="text-sm text-neutral-400" data-id="element-2289">
                    Monthly Payment
                  </span>
                  <span className="text-sm font-medium" data-id="element-2290">RM 5,133</span>
                </div>
              </div>
            </div>
            <div data-id="element-2291">
              <h4 className="font-medium mb-3" data-id="element-2292">Review Status</h4>
              <div className="space-y-3" data-id="element-2293">
                <div className="flex items-center justify-between" data-id="element-2294">
                  <div className="flex items-center" data-id="element-2295">
                    <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-2296" />
                    <span className="text-sm" data-id="element-2297">Digital Advisor Review</span>
                  </div>
                  <span className="text-sm text-success" data-id="element-2298">Approved</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2299">
                  <div className="flex items-center" data-id="element-2300">
                    <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-2301" />
                    <span className="text-sm" data-id="element-2302">Rating Assessment</span>
                  </div>
                  <span className="text-sm text-success" data-id="element-2303">Low Risk (A)</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2304">
                  <div className="flex items-center" data-id="element-2305">
                    <CheckCircleIcon className="w-5 h-5 text-success mr-2" data-id="element-2306" />
                    <span className="text-sm" data-id="element-2307">Shariah Review</span>
                  </div>
                  <span className="text-sm text-success" data-id="element-2308">Approved</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2309">
                  <div className="flex items-center" data-id="element-2310">
                    <AlertCircleIcon className="w-5 h-5 text-warning mr-2" data-id="element-2311" />
                    <span className="text-sm" data-id="element-2312">Contract Signing</span>
                  </div>
                  <span className="text-sm text-warning" data-id="element-2313">Action Required</span>
                </div>
                <div className="flex items-center justify-between" data-id="element-2314">
                  <div className="flex items-center" data-id="element-2315">
                    <ClockIcon className="w-5 h-5 text-neutral-300 mr-2" data-id="element-2316" />
                    <span className="text-sm" data-id="element-2317">Marketplace Listing</span>
                  </div>
                  <span className="text-sm text-neutral-400" data-id="element-2318">Pending</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* E-Signing Modal */}
      {showSigningModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2319">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg" data-id="element-2320">
            <div className="flex justify-between items-center p-4 border-b border-neutral-100" data-id="element-2321">
              <h3 className="font-bold text-lg" data-id="element-2322">Sign Micro-Sukuk Documents</h3>
              <button onClick={() => setShowSigningModal(false)} className="p-1 rounded-full hover:bg-neutral-100 transition-colors" data-id="element-2323">
                <XIcon className="w-5 h-5 text-neutral-400" data-id="element-2324" />
              </button>
            </div>
            <div className="p-4" data-id="element-2325">
              <div className="bg-neutral-50 p-4 rounded-lg mb-4" data-id="element-2326">
                <h4 className="font-medium mb-2" data-id="element-2327">Important Notice</h4>
                <p className="text-sm text-neutral-500" data-id="element-2328">
                  By signing these documents, you agree to the terms and
                  conditions of the micro-sukuk issuance. Please ensure you have
                  reviewed all documents carefully before proceeding.
                </p>
              </div>
              <div className="space-y-4 mb-6" data-id="element-2329">
                <div className="flex items-center" data-id="element-2330">
                  <input type="checkbox" id="terms1" className="mr-2" data-id="element-2331" />
                  <label htmlFor="terms1" className="text-sm" data-id="element-2332">
                    I have reviewed and understand the Murabahah Agreement
                  </label>
                </div>
                <div className="flex items-center" data-id="element-2333">
                  <input type="checkbox" id="terms2" className="mr-2" data-id="element-2334" />
                  <label htmlFor="terms2" className="text-sm" data-id="element-2335">
                    I accept the payment schedule and profit rate
                  </label>
                </div>
                <div className="flex items-center" data-id="element-2336">
                  <input type="checkbox" id="terms3" className="mr-2" data-id="element-2337" />
                  <label htmlFor="terms3" className="text-sm" data-id="element-2338">
                    I understand that this is a legally binding agreement
                  </label>
                </div>
              </div>
              <div className="flex justify-end gap-3" data-id="element-2339">
                <Button variant="outline" onClick={() => setShowSigningModal(false)} data-id="element-2340">
                  Cancel
                </Button>
                <Button variant="primary" icon={<PenToolIcon className="w-4 h-4" data-id="element-2342" />} iconPosition="left" onClick={handleSign} data-id="element-2341">
                  Sign Documents
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default MSMEApplications;